import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import Management from "../pages/Management";
import Awards from "../pages/Awards";
import Milestones from "../pages/Milestones";
import PowerProducts from "../pages/PowerProducts";
import PowerProductDetail from "../pages/PowerProductDetail";
import PowerQuality from "../pages/PowerQuality";
import PowerQualityDetail from "../pages/PowerQualityDetail";
import Footprint from "../pages/Footprint";
import Media from "../pages/Media";
import Investors from "../pages/Investors";
import Sustainability from "../pages/Sustainability";
import SiteDetail from "../pages/SiteDetail";
import Contact from "../pages/Contact";

// The site's public pages. App.js renders a <Route> for each, and the Online
// References page (/OnlineReferences) lists them as the first level of its
// tree - so a page added here shows up there automatically.
//
// Keep `path` and `label` as plain string literals on one line per entry: the
// build-time prerender (frontend/scripts/prerender-references.mjs) reads them
// straight from this file's text, since Node can't import JSX.
export const publicRoutes = [
  { path: "/", label: "Home", element: <Home /> },
  { path: "/about-us", label: "About Us", element: <AboutUs /> },
  { path: "/management", label: "Management", element: <Management /> },
  { path: "/awards-and-accolades", label: "Awards and Accolades", element: <Awards /> },
  { path: "/milestones", label: "Milestones", element: <Milestones /> },
  { path: "/power-products", label: "Power Products", element: <PowerProducts /> },
  { path: "/power-products/:slug", label: "Power Products", element: <PowerProductDetail /> },
  { path: "/power-quality", label: "Power Quality", element: <PowerQuality /> },
  { path: "/power-quality/:slug", label: "Power Quality", element: <PowerQualityDetail /> },
  { path: "/footprint", label: "Footprint", element: <Footprint /> },
  { path: "/media", label: "Media", element: <Media /> },
  { path: "/investors", label: "Investors", element: <Investors /> },
  { path: "/sustainability", label: "Sustainability", element: <Sustainability /> },
  { path: "/sustainability/site/:siteId", label: "Sustainability", element: <SiteDetail /> },
  { path: "/contact", label: "Contact", element: <Contact /> },
];
